//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import arraddinput from "../../../ArrAddInput/index";
import { updateConfig as _updateConfig, listConfig } from '@/api/configurationlist';
import { progressControl } from '@/api/particulars';
import { cloneDeep, isEqual } from 'lodash';
export default {
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      BlacKWhiteList: [{
        value: '',
        label: this.$t('lang.ConfigSetting.Disables')
      }, {
        value: 'ACCEPT',
        label: this.$t('lang.ConfigSetting.black')
      }, {
        value: 'REJECT',
        label: this.$t('lang.ConfigSetting.while')
      }],
      BlacKWhiteValue: '',
      loading: true,
      WatchData: {
        domain: [],
        mode: ''
      },
      data: {}
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler() {
        this.getConfig();
      }
    }
  },
  components: {
    arraddinput: arraddinput
  },
  methods: {
    // 获取配置参数
    getConfig: function getConfig() {
      var _this = this;

      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "domain",
        config: "filter",
        options: [{
          option: "mode"
        }],
        lists: [{
          list: "domain"
        }]
      }]).then(function (res) {
        var data = res.data.data.mess[0];

        _this.$set(_this.data, "mode", data.s_objects[0].options.mode);

        _this.$set(_this.data, "domain", data.s_objects[0].lists.domain);

        _this.WatchData = cloneDeep(_this.data);
        _this.loading = false;
      }).catch(function (err) {
        _this.$message({
          message: _this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    updateConfig: function updateConfig() {
      var _this2 = this;

      if (!isEqual(this.WatchData, this.data)) {
        var data = {};

        for (var key in this.data) {
          data[key] = this.data[key];
        }

        _updateConfig(this.deviceSn, this.deviceDid, [{
          section: "domain",
          config: "filter",
          action: 0,
          index: [0],
          server: 'filter',
          options: {
            mode: data.mode
          },
          lists: {
            domain: data.domain
          }
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            //重启防火墙
            _updateConfig(_this2.deviceSn, _this2.deviceDid, [{
              section: "domain",
              config: "filter",
              action: 0,
              index: [0],
              server: 'firewall',
              options: {
                mode: data.mode
              },
              lists: {
                domain: data.domain
              }
            }]).then(function (res) {
              _this2.$message({
                showClose: true,
                message: _this2.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: 'success'
              });

              _this2.getConfig();
            });
          } else {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });

            return;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    },
    //输入框组件回调
    GetArrList: function GetArrList(props) {
      this.data.domain = props;
    }
  }
};